// Portada del evento: imagen subida o una composición geométrica con el acento de la cuenta,
// para que una organización sin fotos igual tenga una página que se vea bien.

export function EventCover({ shape, imageUrl, alt }: { shape: 'square' | 'wide'; imageUrl?: string | null; alt?: string }) {
  if (imageUrl) {
    return <span className="ev-cover" data-shape={shape}><img src={imageUrl} alt={alt ?? ''} loading="lazy" /></span>;
  }
  return (
    <span className="ev-cover" data-shape={shape} aria-hidden="true">
      {shape === 'square' ? <SquareArt /> : <WideArt />}
    </span>
  );
}

const fill = (v: 'bg' | 'a' | 'b') => ({ fill: `var(--ev-cover-${v})` });
const stroke = (v: 'a' | 'b') => ({ stroke: `var(--ev-cover-${v})` });

function SquareArt() {
  return (
    <svg viewBox="0 0 400 400" width="100%" height="100%" style={{ display: 'block' }}>
      <rect width="400" height="400" style={fill('bg')} />
      <path d="M0 400 L0 190 A210 210 0 0 1 210 400 Z" style={fill('a')} />
      <circle cx="292" cy="108" r="72" style={fill('b')} />
      <rect x="236" y="236" width="128" height="128" fill="none" style={stroke('a')} strokeWidth="14" />
      {[72, 108, 144].flatMap((x) => [64, 100].map((y) => <circle key={`${x}-${y}`} cx={x} cy={y} r="7" style={fill('a')} />))}
    </svg>
  );
}

function WideArt() {
  return (
    <svg viewBox="0 0 1200 450" width="100%" height="100%" preserveAspectRatio="xMidYMid slice" style={{ display: 'block' }}>
      <rect width="1200" height="450" style={fill('bg')} />
      <circle cx="960" cy="225" r="170" style={fill('a')} />
      <path d="M0 450 L0 250 A200 200 0 0 1 200 450 Z" style={fill('b')} />
      <rect x="420" y="120" width="210" height="210" fill="none" style={stroke('a')} strokeWidth="16" />
      {[250, 294, 338].flatMap((x) => [96, 140].map((y) => <circle key={`${x}-${y}`} cx={x} cy={y} r="9" style={fill('a')} />))}
    </svg>
  );
}
